import React from 'react';
import { withTheme } from 'styled-components';
export var SaludIcon = function SaludIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "284px",
    height: "266px",
    viewBox: "0 0 284 266",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Salud"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Salud",
    transform: "translate(-41.000000, -1.000000)",
    fill: theme.colors.primary,
    fillRule: "nonzero"
  }, React.createElement("g", {
    transform: "translate(41.000000, 1.000000)",
    id: "Path"
  }, React.createElement("path", {
    d: "M277.9,146.79 L216.15,146.79 L190.77,88.54 C189.72,86.13 187.22,84.63 184.62,85.02 C182.02,85.32 179.91,87.3 179.46,89.88 L154.96,227.55 L110.82,4.86 C110.27,2.11 107.87,0.1 105.05,0.0693957612 C102.55,0.03 99.78,1.98 99.17,4.72 L64.66,158.88 L6.84,158.88 C3.55,158.88 0.89,161.54 0.89,164.83 C0.89,168.12 3.55,170.78 6.84,170.78 L69.42,170.78 C72.21,170.78 74.62,168.85 75.23,166.13 L104.62,34.85 L149.43,260.9 C149.98,263.68 152.43,265.69 155.27,265.69 C155.29,265.69 155.3,265.69 155.33,265.69 C158.19,265.67 160.63,263.6 161.13,260.78 L187.72,111.33 L206.8,155.1 C207.74,157.26 209.88,158.67 212.25,158.67 L277.89,158.67 C281.18,158.67 283.840112,156.01 283.840112,152.72 C283.86,149.45 281.19,146.79 277.9,146.79 Z"
  })))));
};
export default withTheme(SaludIcon);